
export default class GreencopperReport {
	getKey() {
		return '';
	}

	constructor({
		total,
	}) {
		this._total = total || 0;
	}

	getTotal() {
		return this._total;
	}

	getTotalPercent() {
		return this._total ? 100 : 0;
	}
};
